import { get } from '..';

const getChatbotSessions = (
  isDeleted: boolean = false,
  isBookmarked: boolean = false,
  page: number = 1,
) => get(`chatbot-api/chat-sessions-v2?isDeleted=${isDeleted}&isBookmarked=${isBookmarked}&page=${page}&limit=10`);

export default getChatbotSessions;
